import React, { ReactElement } from "react";

import Checkbox from "../../../../components/forms/Checkbox";
import {
  usePromptConfigEditorOps,
  usePromptConfigEditorState,
} from "../PromptConfigEditor";

export default function ShuffleChoices(): ReactElement {
  const prompt = usePromptConfigEditorState();
  const { updateFields } = usePromptConfigEditorOps();
  return (
    <Checkbox
      label="Shuffle answers"
      checked={!!prompt.definition.inputDisplayConfig?.shuffleChoices}
      onChange={(event) =>
        updateFields({
          inputDisplayConfig: {
            ...prompt.definition.inputDisplayConfig,
            shuffleChoices: event.target.checked,
          },
        })
      }
    />
  );
}
